module.exports = __webpack_public_path__ + "static/media/i8-1-mike.5cc8fa3d.png";